const screen = 0; //paratic
//const screen = 1; //imzapos
 //const screenGercek = 2; //gercek oto
export default {
    screen: screen,
    //screenGercek : screenGercek
}